<template>
  <div id="index">
    <div id="scaleWrap">
      <div class="host-body">
        <!-- 第一行：标题 -->
        <div class="d-flex jc-center">
          <dv-decoration-10 style="width:33.3%;height:5px;" />
          <div class="d-flex jc-center">
            <dv-decoration-8 :color="['#568aea', '#000000']" style="width:160px;height:40px;" />
            <div class="title">
              <span class="title-text">云龙 · 主脑机指挥中心</span>
              <dv-decoration-6
                class="title-bototm"
                :reverse="true"
                :color="['#50e3c2', '#67a1e5']"
                style="width:250px;height:8px;"
              />
            </div>
            <dv-decoration-8
              :reverse="true"
              :color="['#568aea', '#000000']"
              style="width:160px;height:40px;"
            />
          </div>
          <dv-decoration-10 style="width:33.3%;height:5px;" />
        </div>

        <!-- 第二行：状态/时钟 -->
        <div class="d-flex jc-between px-2 row2">
          <div class="d-flex" style="width: 40%">
            <div class="react-right ml-4" style="width: 340px; text-align: left;background-color: #0f1325;">
              <span class="react-before"></span>
              <span class="text fw-b">CPU / 内存 / 磁盘 / 容器 / Pod / 服务</span>
            </div>
            <div class="react-right ml-3" style="background-color: #0f1325;">
              <span class="text colorBlue fw-b">实时监控</span>
            </div>
          </div>
          <div style="width: 40%" class="d-flex">
            <div class="react-left bg-color-blue mr-3">
              <span class="text fw-b">Prometheus</span>
            </div>
            <div class="react-left mr-4" style="width: 340px; background-color: #0f1325; text-align: right;">
              <span class="react-after"></span>
              <span class="text">{{clock}}</span>
            </div>
          </div>
        </div>

        <div class="body-box">
          <!-- 第三行数据：3D拓扑展示区 + 核心指标 + 端口列表 -->
          <div class="content-box">
            <!-- 3D 拓扑展示区（点击区域放大全屏查看） -->
            <div class="topo-embed" @mousedown.stop @touchstart.stop>
              <dv-border-box-12>
                <div class="topo-embed-inner">
                  <div class="topo-embed-head">
                    <span class="topo-embed-title" style="display:none">3D拓扑</span>
                    <span v-if="!shareMode" class="topo-embed-hint" @click.stop="openTopoFull">点击放大 ⛶</span>
                  </div>
                  <iframe
                    class="topo-embed-frame"
                    src="/topo3d/topo-3d.html?v=4&embed=1"
                    frameborder="0"
                    allowfullscreen
                    scrolling="no"
                  ></iframe>
                </div>
              </dv-border-box-12>
            </div>
            <!-- 核心指标（资源/容器/服务/余额/进程TOP8） -->
            <div>
              <center />
            </div>
            <!-- 端口服务列表 -->
            <div>
              <dv-border-box-13>
                <centreRight1 />
              </dv-border-box-13>
            </div>
          </div>

          <!-- 第四行数据 -->
          <div class="bototm-box">
            <dv-border-box-13>
              <bottomLeft />
            </dv-border-box-13>

          </div>
        </div>
      </div>
    </div>

    <!-- 分享功能（2026-08-23 gv-share-mode）：右上角按钮 + 弹层；分享模式时按钮不显示 -->
    <button v-if="!shareMode" class="share-btn" @click.stop="openSharePanel">分享</button>
    <div v-if="sharePanel" class="share-panel" @mousedown.stop @touchstart.stop @click.stop>
      <div class="share-panel-title">🔗 分享大屏</div>
      <div class="share-panel-link" ref="shareUrlText">{{shareUrl}}</div>
      <div class="share-panel-actions">
        <button class="share-act-btn primary" @click.stop="copyShareUrl">复制链接</button>
        <button class="share-act-btn" @click.stop="doShareOff">关闭分享</button>
        <button class="share-act-btn" @click.stop="closeSharePanel">关闭</button>
      </div>
      <div v-if="shareOffMsg" class="share-panel-msg">{{shareOffMsg}}</div>
    </div>
    <div v-if="shareInvalid" class="share-invalid-tip">⚠️ 分享链接已失效，请联系管理员重新分享</div>

    <!-- 3D 拓扑全屏查看遮罩层（独立 iframe，不受缩放影响） -->
    <div v-if="topoFull" class="topo-full" @mousedown.stop @touchstart.stop>
      <iframe
        class="topo-full-frame"
        src="/topo3d/topo-3d.html?v=4"
        frameborder="0"
        allowfullscreen
      ></iframe>
      <button class="topo-full-close" @click.stop="closeTopoFull">⬅ 关闭</button>
    </div>

  </div>
</template>

<script>
import centreRight1 from "./centreRight1";
import center from "./center";
import bottomLeft from "./bottomLeft";

// 设计稿尺寸：1600 x 535（内容栅格实际宽 ~1600px）
const DESIGN_W = 1600;
const DESIGN_H = 535;
const MIN_USER_SCALE = 0.5; // 手动缩放下限 50%
const MAX_USER_SCALE = 3; // 手动缩放上限 300%
const WHEEL_STEP = 0.0012; // 滚轮缩放灵敏度

export default {
  data() {
    return {
      loading: true,
      clock: "",
      userScale: 1, // 手动缩放倍数（相对自动基准，1 = 自动）
      panX: 0, // 水平平移（屏幕像素）
      panY: 0, // 垂直平移（屏幕像素）
      zoomLabel: "100%", // 右下角缩放百分比显示
      panInited: false, // 首次定位标记（初始居中，之后保留用户位置）
      userInteracted: false, // 用户是否已手动拖拽/缩放（此后不再自动干预位置）
      lastContentW: 0, // 上次内容边界（检测布局变化，变化后重新居中）
      lastContentH: 0,
      dragging: false,
      dragStartX: 0,
      dragStartY: 0,
      dragStartPanX: 0,
      dragStartPanY: 0,
      contentW: DESIGN_W, // 内容实际宽（设计像素，getBoundingClientRect 反推）
      contentH: DESIGN_H, // 内容实际高（设计像素）
      lastVw: 0, // 上次视口宽（检测旋转/切屏，未交互时重新居中）
      lastVh: 0,
      lastPortrait: false, // 上次是否竖屏（方向切换时强制重新居中）
      pinchStartDist: 0, // 双指捏合初始距离
      pinchStartScale: 1, // 双指捏合初始 userScale
      pinchActive: false, // 双指捏合进行中（捏合期间看门狗跳过严格 clamp，避免锚点被居中吞掉）
      pinchLastAx: 0, // 上次双指中心 X（等距整体移动时做平移跟随）
      pinchLastAy: 0, // 上次双指中心 Y
      lastTapTime: 0, // 上次单击时间（双击复位检测）
      lastTapX: 0, // 上次单击位置
      lastTapY: 0,
      topoFull: false, // 3D 拓扑全屏查看状态
      shareMode: false, // 分享模式（URL 带 share token）：隐藏余额+禁交互
      shareInvalid: false, // 分享 token 无效提示
      sharePanel: false, // 分享弹层开关
      shareUrl: "", // 生成的分享链接
      shareOffMsg: "" // 分享面板提示（复制成功/已关闭）
    };
  },
  components: {
    centreRight1,
    center,
    bottomLeft
  },
  mounted() {
    this.applyScale();
    window.addEventListener("resize", this.applyScale);
    // 缩放看门狗：手机旋转/浏览器 UI 变化时 resize 可能不触发，每秒校验一次 scale 是否过期
    this.scaleWatchTimer = setInterval(this.watchScale, 1000);
    const el = document.getElementById("index");
    if (el) {
      // 滚轮缩放（中心跟随鼠标）
      el.addEventListener("wheel", this.onWheel, { passive: false });
      // 电脑拖拽平移
      el.addEventListener("mousedown", this.onMouseDown);
      // 桌面双击复位（完整视图）
      el.addEventListener("dblclick", this.onDblClick);
      window.addEventListener("mousemove", this.onMouseMove);
      window.addEventListener("mouseup", this.onMouseUp);
      // 手机触摸平移
      el.addEventListener("touchstart", this.onTouchStart, { passive: true });
      el.addEventListener("touchmove", this.onTouchMove, { passive: false });
      el.addEventListener("touchend", this.onTouchEnd);
      el.addEventListener("touchcancel", this.onTouchEnd);
    }
    this.initShare();
    this.updateClock();
    this.clockTimer = setInterval(this.updateClock, 1000);
    setTimeout(() => {
      this.loading = false;
      // 初始布局稳定后再校正一次 echarts 画布尺寸（初始化过早会得到过期 canvas 尺寸）
      this.resizeStaleCharts();
    }, 800);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.applyScale);
    clearInterval(this.scaleWatchTimer);
    clearInterval(this.clockTimer);
    const el = document.getElementById("index");
    if (el) {
      el.removeEventListener("wheel", this.onWheel);
      el.removeEventListener("mousedown", this.onMouseDown);
      el.removeEventListener("dblclick", this.onDblClick);
      el.removeEventListener("touchstart", this.onTouchStart);
      el.removeEventListener("touchmove", this.onTouchMove);
      el.removeEventListener("touchend", this.onTouchEnd);
      el.removeEventListener("touchcancel", this.onTouchEnd);
    }
    window.removeEventListener("mousemove", this.onMouseMove);
    window.removeEventListener("mouseup", this.onMouseUp);
  },
  methods: {
    // 进入 3D 拓扑页
    goTopo() {
      this.$router.push('/topo');
    },
    // 3D 拓扑全屏放大查看（分享模式禁用：哑屏幕不可交互）
    openTopoFull() {
      if (this.shareMode) return;
      this.topoFull = true;
    },
    closeTopoFull() {
      this.topoFull = false;
    },
    // ===== 分享功能（2026-08-23 gv-share-mode）=====
    // 页面加载时检测 URL ?share=<token>：无论有效与否都进分享模式（余额隐藏+禁交互），
    // token 无效时额外提示「链接已失效」——宁可保守，绝不泄露余额等敏感信息
    initShare() {
      const sp = new URLSearchParams(window.location.search).get("share");
      if (!sp) return;
      this.shareMode = true;
      document.body.classList.add("share-mode");
      // gv-share-click-lock(2026-08-23): 分享模式整屏单击规避——capture 阶段拦截父页面所有 click
      // （分享模式下父页面无可点元素：分享按钮/放大按钮均隐藏；click 拦截不影响滚轮缩放/拖动平移；iframe 内部由 topo-3d.html 的 SHARE_MODE 守卫处理）
      document.addEventListener(
        "click",
        e => {
          e.stopPropagation();
          e.preventDefault();
        },
        true
      );
      fetch("/live/api/share/status?token=" + encodeURIComponent(sp), { cache: "no-store" })
        .then(r => r.json())
        .then(j => { if (!j.valid) this.shareInvalid = true; })
        .catch(() => { /* 静默：失败不阻塞页面 */ });
    },
    // 点「分享」按钮：调后端生成 token，弹层显示链接
    openSharePanel() {
      fetch("/live/api/share/on", { method: "POST", cache: "no-store" })
        .then(r => r.json())
        .then(j => { if (j.url) { this.shareUrl = j.url; this.sharePanel = true; this.shareOffMsg = ""; } })
        .catch(() => { /* 静默：失败不阻塞页面 */ });
    },
    closeSharePanel() {
      this.sharePanel = false;
    },
    // 一键关闭分享：token 立即失效，已发出的链接全部打不开
    doShareOff() {
      fetch("/live/api/share/off", { method: "POST", cache: "no-store" })
        .then(r => r.json())
        .then(j => { if (j.off) { this.shareOffMsg = "已关闭分享，之前的链接已失效"; this.sharePanel = false; } })
        .catch(() => { /* 静默：失败不阻塞页面 */ });
    },
    copyShareUrl() {
      const el = this.$refs.shareUrlText;
      if (!el) return;
      const range = document.createRange();
      range.selectNodeContents(el);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      let ok = false;
      try { ok = document.execCommand("copy"); } catch (e) { /* 复制失败走选中兜底 */ }
      sel.removeAllRanges();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.shareUrl).catch(() => { /* 静默：失败不阻塞页面 */ });
      }
      this.shareOffMsg = ok ? "链接已复制，发出去就能看" : "已选中链接，请手动复制";
    },
    // 读当前 transform 里的实际 scale
    currentScale() {
      const wrap = document.getElementById("scaleWrap");
      if (!wrap) return 1;
      const m = wrap.style.transform.match(/scale\(([\d.]+)\)/);
      return m ? parseFloat(m[1]) : 1;
    },
    // 检测内容实际边界（设计像素）：遍历 host-body 直接子元素 offset（布局坐标，不受 transform/skew 影响）
    updateContentBounds() {
      const wrap = document.getElementById("scaleWrap");
      if (!wrap) return;
      const host = wrap.querySelector(".host-body");
      if (!host) return;
      let maxR = 0;
      let maxB = 0;
      Array.from(host.children).forEach(el => {
        const dx = el.offsetLeft + el.offsetWidth;
        const dy = el.offsetTop + el.offsetHeight;
        if (dx > maxR) maxR = dx;
        if (dy > maxB) maxB = dy;
      });
      if (maxR > 0) this.contentW = maxR;
      if (maxB > 0) this.contentH = maxB;
    },
    // 是否竖屏（高 > 宽）：竖屏时内容容器旋转 90°（方向与 18:04 版相反）消除上下大黑边
    isPortrait() {
      return window.innerHeight > window.innerWidth;
    },
    // 屏幕坐标 → 内容设计坐标（旋转感知）
    // 竖屏 rotate(90deg) 变换链：translate(panX,panY) → rotate(90) → scale(s)
    // 内容点 (dx,dy) 屏幕位置 = (panX - dy*s, panY + dx*s)，反解即本函数
    screenToContent(sx, sy, s) {
      const rot = this.isPortrait();
      if (rot) {
        return { dx: (sy - this.panY) / s, dy: (this.panX - sx) / s };
      }
      return { dx: (sx - this.panX) / s, dy: (sy - this.panY) / s };
    },
    // 内容设计坐标 → 屏幕坐标（旋转感知；用当前 pan 算「当前状态下该内容点的屏幕位置」）
    contentToScreen(dx, dy, s) {
      const rot = this.isPortrait();
      if (rot) {
        return { sx: this.panX - dy * s, sy: this.panY + dx * s };
      }
      return { sx: this.panX + dx * s, sy: this.panY + dy * s };
    },
    // 锚点缩放专用：解算「使内容点 (dx,dy) 落在屏幕 (ax,ay)」的目标 pan（旋转感知）
    // ⚠️ 不能用 contentToScreen(c, sNew) 当新 pan —— 它用当前 pan 当基准（sx=panX+dx*s），
    //    锚点公式需要的是「目标 pan」= 锚点屏幕坐标 - 内容点在新 scale 下的偏移，差一个锚点项，
    //    实测会把锚点当成原点(0,0)，缩放中心乱跳（8/21 双指缩放锚点任务实测根因）。
    panForAnchor(ax, ay, dx, dy, sNew) {
      const rot = this.isPortrait();
      if (rot) {
        // 竖屏 rotate90：sx = panX - dy*s、sy = panY + dx*s → panX = sx + dy*s、panY = sy - dx*s
        return { panX: ax + dy * sNew, panY: ay - dx * sNew };
      }
      // 横屏/桌面：sx = panX + dx*s、sy = panY + dy*s → panX = sx - dx*s、panY = sy - dy*s
      return { panX: ax - dx * sNew, panY: ay - dy * sNew };
    },
    // 自动基准缩放：contain 完整显示（2026-08-21 大哥指令）
    // 横屏/桌面：scale = min(视口宽/内容宽, 视口高/内容高)，零旋转，与改造前完全一致
    // 竖屏：内容旋转 90°（方向为 8/21 18:04 版 rotate(-90deg) 的反向）后有效尺寸互换（屏幕宽=内容高*s、屏幕高=内容宽*s），
    //       scale = min(视口宽/内容高, 视口高/内容宽)——竖屏 390×844 下黑边从 306px 降至 ~93px
    baseScale() {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      if (this.isPortrait()) {
        return Math.min(vw / this.contentH, vh / this.contentW);
      }
      const sW = vw / this.contentW; // 按内容实际宽铺满
      const sH = vh / this.contentH; // 按内容实际高铺满
      return Math.min(sW, sH);
    },
    // 平移范围限制：内容在屏幕上的包围盒为 [0, bw] × [0, bh]（竖屏旋转后宽高互换）
    // 内容窄/矮则固定居中，否则 clamp 让内容覆盖视口（可平移不露黑边）
    clampPan(s) {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const rot = this.isPortrait();
      if (rot) {
        // 竖屏旋转后包围盒：x ∈ [panX - ch*s, panX]（内容在 x 负半轴，靠 panX 拉回），y ∈ [panY, panY + cw*s]（正半轴）
        const bw = this.contentH * s;
        const bh = this.contentW * s;
        if (bw <= vw) {
          this.panX = vw / 2 + bw / 2;
        } else {
          // 左不露：panX - bw ≤ 0 → panX ≤ bw；右不露：panX ≥ vw
          this.panX = Math.max(vw, Math.min(bw, this.panX));
        }
        if (bh <= vh) {
          this.panY = vh / 2 - bh / 2;
        } else {
          // 上不露：panY ≤ 0；下不露：panY + bh ≥ vh → panY ≥ vh - bh
          this.panY = Math.max(vh - bh, Math.min(0, this.panY));
        }
        return;
      }
      const bw = this.contentW * s;
      const bh = this.contentH * s;
      if (bw <= vw) {
        this.panX = vw / 2 - bw / 2;
      } else {
        this.panX = Math.max(vw - bw, Math.min(0, this.panX));
      }
      if (bh <= vh) {
        this.panY = vh / 2 - bh / 2;
      } else {
        this.panY = Math.max(vh - bh, Math.min(0, this.panY));
      }
    },
    // 宽松平移边界（双指捏合缩放中用）：锚点优先，只防止内容完全离开视口（允许露黑边），不强制居中。
    // 严格 clampPan 在内容≤视口时强制居中，会吞掉锚点补偿 → 表现成「固定以屏幕中心为原点缩放」。
    clampPanSoft(s) {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const rot = this.isPortrait();
      if (rot) {
        // 竖屏 rotate(90)：内容屏幕包围盒 x∈[panX-bw, panX]、y∈[panY, panY+bh]
        const bw = this.contentH * s;
        const bh = this.contentW * s;
        // 与视口 [0,vw]×[0,vh] 保持交集：panX ∈ [0, vw+bw]、panY ∈ [-bh, vh]
        this.panX = Math.max(0, Math.min(vw + bw, this.panX));
        this.panY = Math.max(-bh, Math.min(vh, this.panY));
        return;
      }
      // 横屏/桌面：内容包围盒 x∈[panX, panX+bw]、y∈[panY, panY+bh]
      const bw = this.contentW * s;
      const bh = this.contentH * s;
      this.panX = Math.max(-bw, Math.min(vw, this.panX));
      this.panY = Math.max(-bh, Math.min(vh, this.panY));
    },
    // 内容居中（首次定位/布局变化时使用；竖屏旋转后包围盒宽高互换）
    centerPan(s) {
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const rot = this.isPortrait();
      if (rot) {
        // 内容在屏幕 x ∈ [panX - ch*s, panX]、y ∈ [panY, panY + cw*s]，居中 → panX = vw/2 + ch*s/2、panY = vh/2 - cw*s/2
        this.panX = vw / 2 + (this.contentH * s) / 2;
        this.panY = vh / 2 - (this.contentW * s) / 2;
        return;
      }
      this.panX = vw / 2 - (this.contentW * s) / 2;
      this.panY = vh / 2 - (this.contentH * s) / 2;
    },
    // 轻量写 transform（拖拽过程中用，不重算 scale）
    setTransform() {
      const wrap = document.getElementById("scaleWrap");
      if (!wrap) return;
      const s = this.currentScale();
      const rot = this.isPortrait();
      wrap.style.transform = `translate(${this.panX}px, ${this.panY}px)${
        rot ? " rotate(90deg)" : ""
      } scale(${s})`;
    },
    // 核心：按当前模式重算 scale + 平移，写入 transform
    // softClamp=true 时用 clampPanSoft（捏合缩放中锚点优先，不强制居中）
    applyScale(softClamp) {
      const wrap = document.getElementById("scaleWrap");
      if (!wrap) return;
      this.updateContentBounds();
      const s = this.baseScale() * this.userScale;
      // 首次定位 / 视口变化（切屏/窗口调整）/ 布局变化（数据组件渲染完成改变边界）且用户未手动干预 → 居中
      const vwNow = window.innerWidth;
      const vhNow = window.innerHeight;
      const rotNow = this.isPortrait();
      const vpChanged = Math.abs(vwNow - this.lastVw) > 1 || Math.abs(vhNow - this.lastVh) > 1;
      const rotChanged = rotNow !== this.lastPortrait;
      if (
        !this.panInited ||
        rotChanged ||
        (!this.userInteracted &&
          (vpChanged || Math.abs(this.contentW - this.lastContentW) > 2))
      ) {
        this.centerPan(s);
        this.panInited = true;
      }
      this.lastVw = vwNow;
      this.lastVh = vhNow;
      this.lastPortrait = rotNow;
      this.lastContentW = this.contentW;
      this.lastContentH = this.contentH;
      if (softClamp) {
        this.clampPanSoft(s);
      } else {
        this.clampPan(s);
      }
      // 竖屏：内容旋转 90°（8/21 18:04 版 rotate(-90deg) 的反向；translate 在旋转外层，panX/panY 恒为屏幕像素）
      wrap.style.transform = `translate(${this.panX}px, ${this.panY}px)${
        rotNow ? " rotate(90deg)" : ""
      } scale(${s})`;
      wrap.style.transformOrigin = "0 0";
      wrap.style.position = "absolute";
      wrap.style.left = "0";
      wrap.style.top = "0";
      wrap.style.marginLeft = "0";
      wrap.style.marginTop = "0";
      wrap.style.width = DESIGN_W + "px";
      wrap.style.height = DESIGN_H + "px";
      wrap.style.overflow = "visible"; // 去掉裁剪：平移/缩放能看到全部内容
      this.zoomLabel = Math.round(this.userScale * 100) + "%";
    },
    // 看门狗：校验 scale 与「自动基准 × 手动倍数」匹配，不匹配立即重算（保留手动缩放/平移状态）
    watchScale() {
      // 双指捏合进行中：跳过（严格 clamp 会把锚点拉回中心，破坏锚点缩放；松手后 applyScale 统一稳定化）
      if (this.pinchActive) return;
      const wrap = document.getElementById("scaleWrap");
      if (!wrap) return;
      const m = wrap.style.transform.match(/scale\(([\d.]+)\)/);
      const current = m ? parseFloat(m[1]) : -1;
      this.updateContentBounds();
      const expected = this.baseScale() * this.userScale;
      const layoutChanged =
        Math.abs(this.contentW - this.lastContentW) > 2 ||
        Math.abs(this.contentH - this.lastContentH) > 2;
      if (Math.abs(current - expected) > 0.001 || layoutChanged) this.applyScale();
      this.resizeStaleCharts();
    },
    // 校正 echarts 画布尺寸：容器宽度变化（grid 定轨/数据加载/切屏重排）后 canvas 可能过期，
    // 过期画布会画出容器边界压到相邻区块（实测 bottom 图 932px 画布压在 772px 容器上跨块穿插）。
    // 只在实际不匹配时 resize（每秒调用也零开销）
    resizeStaleCharts() {
      if (!this.echartsLib) {
        try {
          this.echartsLib = require("echarts");
        } catch (e) {
          return;
        }
      }
      const es = this.echartsLib;
      if (!es || !es.getInstanceByDom) return;
      const wrap = document.getElementById("scaleWrap");
      if (!wrap) return;
      const dpr = window.devicePixelRatio || 1;
      const seen = [];
      wrap.querySelectorAll("canvas").forEach(cv => {
        if (cv.width <= 0) return;
        // 从 canvas 向上找 echarts 容器：echarts5 会在容器内套一层 div，
        // canvas 的直接父级不是 init 容器，getInstanceByDom 必须用 init 容器
        let node = cv.parentElement;
        while (node && node !== wrap) {
          try {
            const inst = es.getInstanceByDom(node);
            if (inst && typeof inst.resize === "function") {
              if (seen.indexOf(node) === -1) {
                seen.push(node);
                const target = Math.round(node.clientWidth * dpr);
                if (Math.abs(cv.width - target) > 2) inst.resize();
              }
              return;
            }
          } catch (e) {
            return;
          }
          node = node.parentElement;
        }
      });
    },
    // ③滚轮缩放：缩放中心跟随鼠标指针（保持鼠标下的内容点不动，旋转感知）
    onWheel(e) {
      this.userInteracted = true;
      const factor = Math.exp(-e.deltaY * WHEEL_STEP);
      const next = Math.min(MAX_USER_SCALE, Math.max(MIN_USER_SCALE, this.userScale * factor));
      if (Math.abs(next - this.userScale) < 0.001) return;
      const sOld = this.baseScale() * this.userScale;
      const sNew = this.baseScale() * next;
      // 先把鼠标下的屏幕点换算成设计坐标，缩放后再映射回屏幕，保持该点不动（旋转感知）
      const c = this.screenToContent(e.clientX, e.clientY, sOld);
      this.userScale = next;
      const p = this.panForAnchor(e.clientX, e.clientY, c.dx, c.dy, sNew);
      this.panX = p.panX;
      this.panY = p.panY;
      this.applyScale();
      if (e.cancelable) e.preventDefault();
    },
    // ②电脑拖拽平移
    onMouseDown(e) {
      if (e.target.closest(".topo-embed, .topo-full, .share-btn, .share-panel")) return;
      this.userInteracted = true;
      this.dragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.dragStartPanX = this.panX;
      this.dragStartPanY = this.panY;
      if (e.cancelable) e.preventDefault();
    },
    onMouseMove(e) {
      if (!this.dragging) return;
      this.panX = this.dragStartPanX + (e.clientX - this.dragStartX);
      this.panY = this.dragStartPanY + (e.clientY - this.dragStartY);
      this.clampPan(this.currentScale());
      this.setTransform();
    },
    onMouseUp() {
      this.dragging = false;
    },
    // ②手机触摸：单指平移 + 双指捏合缩放 + 双击复位（旋转感知）
    onTouchStart(e) {
      const now = Date.now();
      // 双击复位：与上次单击间隔 <400ms 且位置接近 → 复位回完整视图
      // （400ms 兼顾真实双击习惯与浏览器后台节流导致的定时偏差）
      if (
        e.touches.length === 1 &&
        this.lastTapTime &&
        now - this.lastTapTime < 400 &&
        Math.abs(e.touches[0].clientX - this.lastTapX) < 30 &&
        Math.abs(e.touches[0].clientY - this.lastTapY) < 30
      ) {
        this.lastTapTime = 0;
        this.zoomReset();
        return;
      }
      if (e.touches.length === 1) {
        this.lastTapTime = now;
        this.lastTapX = e.touches[0].clientX;
        this.lastTapY = e.touches[0].clientY;
      }
      if (e.target.closest(".topo-embed, .topo-full, .share-btn, .share-panel")) return;
      // 双指捏合开始
      if (e.touches.length === 2) {
        this.pinchStartDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        this.pinchStartScale = this.userScale;
        this.pinchActive = true;
        this.pinchLastAx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        this.pinchLastAy = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        this.dragging = false;
        return;
      }
      if (e.touches.length !== 1) return;
      this.userInteracted = true;
      this.dragging = true;
      this.dragStartX = e.touches[0].clientX;
      this.dragStartY = e.touches[0].clientY;
      this.dragStartPanX = this.panX;
      this.dragStartPanY = this.panY;
    },
    onTouchMove(e) {
      // 双指捏合缩放：以双指实时中心点为锚点（手指在哪，哪就是缩放中心，旋转感知）
      // 锚点公式：缩放前后锚点在内容坐标系坐标不变 —— pan' = panForAnchor(锚点, screenToContent(锚点, sOld), sNew)
      // 锚点每帧取最新双指中心 → 捏合过程中手指滑动，锚点实时跟随
      if (e.touches.length === 2 && this.pinchStartDist > 0) {
        this.userInteracted = true;
        this.pinchActive = true;
        const dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        const next = Math.min(
          MAX_USER_SCALE,
          Math.max(MIN_USER_SCALE, this.pinchStartScale * (dist / this.pinchStartDist))
        );
        const ax = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        const ay = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        const scaleChanged = Math.abs(next - this.userScale) >= 0.001;
        const centerMoved =
          Math.abs(ax - this.pinchLastAx) > 0.5 || Math.abs(ay - this.pinchLastAy) > 0.5;
        if (scaleChanged) {
          // 缩放：保持当前双指中心下的内容点不动（锚点缩放）
          const sOld = this.baseScale() * this.userScale;
          const sNew = this.baseScale() * next;
          const c = this.screenToContent(ax, ay, sOld);
          this.userScale = next;
          const p = this.panForAnchor(ax, ay, c.dx, c.dy, sNew);
          this.panX = p.panX;
          this.panY = p.panY;
        } else if (centerMoved) {
          // 双指等距整体移动：画面跟随手指平移（锚点实时跟随）
          this.panX += ax - this.pinchLastAx;
          this.panY += ay - this.pinchLastAy;
        }
        this.pinchLastAx = ax;
        this.pinchLastAy = ay;
        // 软 clamp：捏合中锚点优先，只防内容完全离开视口，不强制居中（严格居中会吞掉锚点补偿）
        this.applyScale(true);
        if (e.cancelable) e.preventDefault();
        return;
      }
      if (!this.dragging || e.touches.length !== 1) return;
      this.panX = this.dragStartPanX + (e.touches[0].clientX - this.dragStartX);
      this.panY = this.dragStartPanY + (e.touches[0].clientY - this.dragStartY);
      this.clampPan(this.currentScale());
      this.setTransform();
      if (e.cancelable) e.preventDefault(); // 阻止页面滚动/浏览器手势
    },
    onTouchEnd(e) {
      // 双指→单指：重新以剩余手指为起点继续拖拽（无跳变）
      if (e.touches.length === 1 && this.pinchStartDist > 0) {
        this.pinchStartDist = 0;
        this.pinchActive = false;
        this.dragging = true;
        this.userInteracted = true;
        this.dragStartX = e.touches[0].clientX;
        this.dragStartY = e.touches[0].clientY;
        this.dragStartPanX = this.panX;
        this.dragStartPanY = this.panY;
        return;
      }
      if (e.touches.length === 0) {
        this.dragging = false;
        this.pinchStartDist = 0;
        this.pinchActive = false;
        // 松手稳定化：内容仍≤视口 → 严格 clamp 自动回中（缩放效果保留）；内容>视口 → 防露边保留位置
        this.applyScale();
      }
    },
    // 桌面双击复位（完整视图）
    onDblClick() {
      this.zoomReset();
    },
    // ③缩放按钮（右下角）
    zoomIn() {
      this.userInteracted = true;
      this.userScale = Math.min(MAX_USER_SCALE, this.userScale * 1.15);
      this.applyScale();
    },
    zoomOut() {
      this.userInteracted = true;
      this.userScale = Math.max(MIN_USER_SCALE, this.userScale / 1.15);
      this.applyScale();
    },
    zoomReset() {
      this.userInteracted = true;
      this.userScale = 1;
      this.panInited = false; // 复位后重新居中
      this.applyScale();
    },
    // ②左右平移按钮（恒水平平移）
    panLeft() {
      this.userInteracted = true;
      this.panX -= window.innerWidth * 0.1;
      this.clampPan(this.currentScale());
      this.setTransform();
    },
    panRight() {
      this.userInteracted = true;
      this.panX += window.innerWidth * 0.1;
      this.clampPan(this.currentScale());
      this.setTransform();
    },
    updateClock() {
      const d = new Date();
      const week = ["日", "一", "二", "三", "四", "五", "六"][d.getDay()];
      const p = n => (n < 10 ? "0" + n : "" + n);
      this.clock =
        `${d.getFullYear()}年${p(d.getMonth() + 1)}月${p(d.getDate())}日 周${week} ` +
        `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/index.scss";

#scaleWrap {
  touch-action: none; // 触摸手势全部交给页面处理，防止浏览器滚动/双指缩放干扰
}

/* ===== 3D 拓扑展示区（大屏内嵌） ===== */
.topo-embed {
  height: 720px;
  cursor: pointer;
  position: relative;
}

.topo-embed-inner {
  height: 680px;
  margin: 1rem;
  border-radius: 10px;
  background: #0f1325;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.topo-embed-head {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 6px 10px;
  border-bottom: 1px solid rgba(80, 227, 194, 0.15);
}

.topo-embed-title {
  color: #5cd9e8;
  font-size: 16px;
  font-weight: 700;
}

.topo-embed-hint {
  cursor: pointer;
  color: #50e3c2;
  font-size: 12px;
  border: 1px solid rgba(80, 227, 194, 0.4);
  border-radius: 4px;
  padding: 1px 8px;
  background: rgba(80, 227, 194, 0.12);
}

.topo-embed-frame {
  flex: 1 1 auto;
  width: 100%;
  border: none;
  display: block;
  background: #05060a;
}

/* ===== 3D 拓扑全屏查看遮罩层 ===== */
.topo-full {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: #05060a;
  overflow: hidden;
}

.topo-full-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.topo-full-close {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 3001;
  background: rgba(5, 9, 18, 0.72);
  color: #cfe9ff;
  border: 1px solid rgba(90, 180, 255, 0.45);
  border-radius: 8px;
  padding: 6px 14px;
  font-size: 14px;
  cursor: pointer;
  backdrop-filter: blur(4px);
}

.topo-full-close:hover {
  background: rgba(30, 60, 110, 0.85);
  color: #fff;
}

/* ===== 分享功能（2026-08-23 gv-share-mode）===== */
.share-btn {
  position: fixed;
  top: 12px;
  right: 14px;
  z-index: 2500;
  padding: 6px 16px;
  font-size: 14px;
  /* gv-share-btn-shrink(2026-08-23): 按钮整体缩为 1/2 长、高等比（transform 等比缩放，锚定右上角不位移） */
  transform: scale(0.5);
  transform-origin: top right;
  font-weight: 600;
  color: #50e3c2;
  background: rgba(15, 19, 37, 0.85);
  border: 1px solid rgba(80, 227, 194, 0.55);
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 0 12px rgba(80, 227, 194, 0.25);
  letter-spacing: 1px;
  backdrop-filter: blur(3px);
}
.share-btn:hover {
  background: rgba(30, 60, 110, 0.9);
  color: #fff;
  box-shadow: 0 0 18px rgba(80, 227, 194, 0.5);
}
.share-panel {
  position: fixed;
  top: 60px;
  right: 14px;
  z-index: 2501;
  width: 360px;
  padding: 14px 16px;
  background: rgba(8, 12, 24, 0.95);
  border: 1px solid rgba(80, 227, 194, 0.45);
  border-radius: 10px;
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.6);
  color: #c3cbde;
  backdrop-filter: blur(6px);
}
.share-panel-title {
  font-size: 15px;
  font-weight: 700;
  color: #50e3c2;
  margin-bottom: 10px;
}
.share-panel-link {
  font-size: 13px;
  line-height: 1.5;
  word-break: break-all;
  padding: 8px 10px;
  background: #0f1325;
  border: 1px solid rgba(90, 180, 255, 0.3);
  border-radius: 6px;
  color: #8fd0ff;
  user-select: all;
}
.share-panel-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.share-act-btn {
  flex: 1;
  padding: 6px 0;
  font-size: 13px;
  color: #c3cbde;
  background: rgba(15, 19, 37, 0.9);
  border: 1px solid rgba(90, 180, 255, 0.4);
  border-radius: 6px;
  cursor: pointer;
}
.share-act-btn.primary {
  color: #05060a;
  background: #50e3c2;
  border-color: #50e3c2;
  font-weight: 700;
}
.share-act-btn:hover {
  background: rgba(30, 60, 110, 0.9);
  color: #fff;
}
.share-act-btn.primary:hover {
  background: #6cf0d2;
}
.share-panel-msg {
  margin-top: 10px;
  font-size: 12px;
  color: #facc15;
}
.share-invalid-tip {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2600;
  padding: 8px 18px;
  font-size: 14px;
  color: #ffd9a0;
  background: rgba(60, 30, 5, 0.92);
  border: 1px solid rgba(255, 170, 60, 0.6);
  border-radius: 8px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.5);
}
</style>

<style lang="scss">
/* 分享模式全局规则（2026-08-23 gv-share-mode）：隐藏 DeepSeek 余额，跨组件生效 */
body.share-mode #bottomLeft .ds-balance {
  display: none !important;
}
</style>
